import { useForm } from 'react-hook-form';

import { DailySchedulesWithDeliveryFormData } from '../types';

type TUseDailySchedulesWithDeliveryFormProps = {
  defaultValues?: Partial<DailySchedulesWithDeliveryFormData>;
};

export function useDailySchedulesWithDeliveryForm({
  defaultValues,
}: TUseDailySchedulesWithDeliveryFormProps = {}) {
  return useForm<DailySchedulesWithDeliveryFormData>({
    mode: 'all',
    defaultValues: {
      schedules: [],
      ...defaultValues,
    },
  });
}
